import qs from 'qs';
import 'whatwg-fetch';
// tslint:disable
let request = (url, body) => {
    let options = {
        method:'get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        credentials: 'include',
        fail:true
    }
    for (let i in body) {
        options[i] = body[i]
    }
    let timout = new Promise((resolve, reject) => {
        setTimeout(() => {
            reject('请求超时');
        }, 5000);
    });
    return Promise.race([fetch('/api' + url + '?' + qs.stringify(options.data), options).then((res) => {
        return res.json()
    }).then((response) => {
        if (response) {
            if (response.flag) {
                return response;
            } else {
                if (response.msg) {
                    window.alert(response.msg);
                }
                return new Promise(() => {})
            }
        }
    })
        .catch((err) => {
            throw err;
        }), timout
    ]).catch((err) => {
        // if (err =='请求超时'){
        //     myalert('请求超时')
        // }
        throw err;
    })
}
export default request;
